import type { SyncConditionInfo } from '@/features/Setting/Integrations/providers/types';
import { defaultAxios } from '@/services/index';

const salesforceService = {
  async createSalesforceInfo(
    userId: string,
    password: string,
    consumerKey: string,
    consumerSecret: string,
    workspaceAlias: string,
  ) {
    const formData = new FormData();
    formData.append('client_id', consumerKey);
    formData.append('client_secret', consumerSecret);
    formData.append('user_id', userId);
    formData.append('password', password);
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/salesforce/register`,
        formData,
        // {
        //   client_id: consumerKey,
        //   client_secret: consumerSecret,
        //   user_id: userId,
        //   password,
        // },
      );
      const { alias, user_id, state, history, auto_sync, sync_condition_info } =
        res.data;
      return { alias, user_id, state, history, auto_sync, sync_condition_info };
    } catch (e) {
      throw e;
    }
  },
  async updateSalesforceInfo(
    userId: string,
    password: string,
    consumerKey: string,
    consumerSecret: string,
    workspaceAlias: string,
  ) {
    const formData = new FormData();
    formData.append('client_id', consumerKey);
    formData.append('client_secret', consumerSecret);
    formData.append('user_id', userId);
    formData.append('password', password);
    try {
      const res = await defaultAxios.patch(
        `/workspaces/${workspaceAlias}/salesforce/update`,
        formData,
        // {
        //   client_id: consumerKey,
        //   client_secret: consumerSecret,
        //   user_id: userId,
        //   password,
        // },
      );
      const { alias, user_id, state, history, auto_sync, sync_condition_info } =
        res.data;
      return { alias, user_id, state, history, auto_sync, sync_condition_info };
    } catch (e) {
      throw e;
    }
  },
  async deleteSalesforceInfo(alias: string) {
    try {
      await defaultAxios.delete(`/salesforce/${alias}`);
      return true;
    } catch (e) {
      return false;
    }
  },
  async getSalesforceTaskFieldInfo(alias: string) {
    try {
      const res = await defaultAxios.get(`/salesforce/${alias}/task_field`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async getSalesforceInfo(workspaceAlias: string) {
    try {
      const res = await defaultAxios.get(
        `/workspaces/${workspaceAlias}/salesforce/`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async syncSalesforceInfo(alias: string) {
    try {
      const res = await defaultAxios.post(`/salesforce/${alias}/sync`);
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async updateSalesforceAutoSync(alias: string, sync: boolean) {
    try {
      const res = await defaultAxios.patch(`/salesforce/${alias}/auto`, {
        auto_sync: sync,
      });
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async importSalesforceInfo(
    alias: string,
    accountSync: boolean,
    taskSync: boolean,
    startDate?: string,
    endDate?: string,
    syncConditionInfo?: SyncConditionInfo[],
  ) {
    try {
      const res = await defaultAxios.post(`/salesforce/${alias}/import`, {
        account_sync: accountSync,
        task_sync: taskSync,
        start_date: startDate,
        end_date: endDate,
        sync_condition_info: syncConditionInfo,
      });
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};

export default salesforceService;
